const QR_DIALOG_TIMEOUT_MS = 10000;

export default function qrDialogTimeout(dialogProperty) {
  return {
    data() {
      return { qrDialogTimer: null, qrDialogGeneration: 0 };
    },
    watch: {
      [dialogProperty](isOpen) {
        if (!isOpen) this.clearQrDialogTimeout();
      },
      $route() {
        this.closeQrDialog();
      },
      totemId() {
        this.closeQrDialog();
      },
    },
    beforeDestroy() {
      this.closeQrDialog();
    },
    methods: {
      openQrDialog() {
        this.clearQrDialogTimeout();
        this[dialogProperty] = true;
        const generation = this.qrDialogGeneration;
        this.qrDialogTimer = window.setTimeout(() => {
          this.closeQrDialog();
        }, QR_DIALOG_TIMEOUT_MS);
        return generation;
      },
      clearQrDialogTimeout() {
        if (this.qrDialogTimer !== null) {
          window.clearTimeout(this.qrDialogTimer);
          this.qrDialogTimer = null;
        }
        this.qrDialogGeneration += 1;
      },
      closeQrDialog() {
        this[dialogProperty] = false;
        this.clearQrDialogTimeout();
      },
      isQrDialogRequestCurrent(generation) {
        return this[dialogProperty] && this.qrDialogGeneration === generation;
      },
    },
  };
}
